import * as React from 'react'
import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

export const TitleAndText = ({ slice }) => {
  const {title, text} = slice.primary

  return (
    <div className={"py-70"}>
      <div className="container">
      {title && <h2 className="text-center card-title" style={{margin:"0 0 24px 0"}}>{title}</h2>}
        <div className="">
          <PrismicRichText field={text.richText} />
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  fragment HomepageDataBodyTitleAndText on PrismicHomepageDataBodyTitleAndText {
    primary {
      title
      text {
        richText
      }
    }
  }
  fragment PageDataBodyTitleAndText on PrismicPageDataBodyTitleAndText {
    primary {
      title
      text {
        richText
      }
    }
  }
`
